import {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {postAuthPassword} from 'api/auth';
import {useAuth} from 'contexts/AuthContext';
import {alertByError, alertError} from 'utils/alerts';
import Cookies from 'utils/cookies';

function useLoginPassword(callback) {
  const [isLoading, setIsLoading] = useState(false);
  const {setSession} = useAuth();
  const history = useHistory();

  useEffect(() => {
    return () => setIsLoading(false);
  }, []);

  async function loginPassword(formData) {
    setIsLoading(true);
    try {
      const {data} = await postAuthPassword(formData);

      const {session_id, account, consent, permission} = data;

      if (session_id) {
        await setSession(
          {token: session_id, account, consent, permission},
          true
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
        if (callback) callback(data);
      }
    } catch (e) {
      const {code} = e;

      if (code === 'invalid_email_token') {
        Cookies.emailSession = '';
        history.push('/login');
      }

      setIsLoading(false);

      const {meta} = e || {};
      const {login_tries} = meta || {};

      if (login_tries === 5) {
        const {value} = await alertError({
          html: `<div>
              <p>Unable to log in with provided credentials</p>

              <p>
                You have <b>1 attempt remaining</b>. Would you like to reset
                your password?
              </p>
            </div>`,
          title: 'Failure',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          showConfirmButton: true,
          confirmButtonText: 'Reset your password',
        });

        if (value) {
          history.push('/forgot/password');
        }
        return;
      } else {
        await alertByError(e, {title: 'Login Attempt Failed.'});
      }
    }
  }

  return {isLoading, loginPassword};
}

export default useLoginPassword;
